module.exports = require('./generateRecipePlaygroundComponent')
